import { useRef, useCallback, useState, useEffect, createElement } from "react";
import Button from "@mui/material/Button";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useTranslation } from "react-i18next";
export const filterReducer = (state: any = [], action: any = {}) => {
  switch (action.type) {
    case "setValue": {
      const { id, ...others } = action.payload;
      let index = state.findIndex((one) => one.id === id);
      if (index >= 0) {
        state[index].value = others;
        return [...state];
      }
      return [...state, { id, value: others }];
    }
    case "removeValue": {
      const { id } = action.payload;
      /* eslint-disable eqeqeq */
      let result = state.filter((one) => one.id != id);
      return result;
    }
    case "resetAll": {
      return [];
    }
    default: {
      return state;
    }
  }
};

export const useFilterState = (reducer) => {
  const filterState = useRef<object>([]);
  /* eslint-disable react-hooks/exhaustive-deps */
  const dispatch = useCallback((action) => {
    let newState = reducer(filterState.current, action);
    filterState.current = newState;
  }, []);

  return {
    dispatch,
    filterState,
  };
};

export const FilterComponent = ({
  setQueryFilters,
  filterMeta,
  filterData,
  retrievalType,
  isOpenRetrievalDefault,
  setShowFilters,
  setAllFilters,
  retrievalComponent,
}) => {
  const [open, setOpen] = useState(isOpenRetrievalDefault);
  const refFilteredData = useRef<any>(filterData);
  // const classes = useStyles();
  const { t } = useTranslation();
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
    setShowFilters(false);
    setAllFilters([]);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && (event.key === "R" || event.key === "r")) {
        event.preventDefault();
        setOpen(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
  }, []);

  const retrievalParaValues = (retrievalValues, orgData) => {
    setQueryFilters(retrievalValues);
    setOpen(false);
    if (orgData) {
      refFilteredData.current = orgData;
    }
  };

  const setRetrievalData = (data) => {
    setQueryFilters([data]);
    setOpen(false);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <>
        {Boolean(retrievalType) && typeof retrievalComponent === "function" ? (
          <>
            {(retrievalType === "CUSTOM" && filterMeta?.fields?.length > 0) ||
            retrievalType !== "CUSTOM" ? (
              <Button onClick={handleOpen} color="primary">
                {t("RetrieveData")}
              </Button>
            ) : null}
          </>
        ) : (
          <></>
        )}
        {open &&
        retrievalType &&
        retrievalComponent &&
        typeof retrievalComponent === "function"
          ? createElement(retrievalComponent, {
              classes: {},
              open,
              handleClose,
              loginState: {},
              defaultData: refFilteredData.current,
              retrievalParaValues,
              retrievalType,
              metaData: filterMeta,
            })
          : null}
      </>
    </LocalizationProvider>
  );
};
